export const API_INFO_IOS = {
  APIS: [
    {
      api: 'SKCloudServiceController#requestAuthorization:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'AppleMusic',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'AppleMusic',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CBCentralManager#initWithDelegate:queue:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      lx_description: '蓝牙',
      lx_module: 'BLUETOOTH_MAC_ADDRESS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Bluetooth',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CBCentralManager#initWithDelegate:queue:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      lx_description: '蓝牙',
      lx_module: 'BLUETOOTH_MAC_ADDRESS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Bluetooth',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CBPeripheralManager#initWithDelegate:queue:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Bluetooth',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CBPeripheralManager#initWithDelegate:queue:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '蓝牙',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Bluetooth',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#calendarWithIdentifier:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: '日历',
      lx_module: 'CALENDAR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#calendarsForEntityType:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: '日历',
      lx_module: 'CALENDAR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#eventsMatchingPredicate:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: '日历',
      lx_module: 'CALENDAR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#predicateForEventsWithStartDate:endDate:calendars:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: '日历',
      lx_module: 'CALENDAR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#requestAccessToEntityType:completion:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: '日历',
      lx_module: 'CALENDAR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#requestFullAccessToEventsWithCompletion:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#requestFullAccessToRemindersWithCompletion:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#requestWriteOnlyAccessToEventsWithCompletion:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'EKEventStore#saveEvent:span:commit:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '日历与提醒',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Calendars/Reminders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVCaptureDevice#requestAccessForMediaType:completionHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      lx_description: '相机',
      lx_module: 'TAKE_PICTURE',
      lx_show: true,
      lx_useflag: 0,
      module: 'Camera',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVCaptureSession#startRunning',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相机',
      lx_description: '相机',
      lx_module: 'TAKE_PICTURE',
      lx_show: true,
      lx_useflag: 0,
      module: 'Camera',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CTTelephonyNetworkInfo#serviceSubscriberCellularProviders',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '运营商',
      lx_description: '运营商信息',
      lx_module: 'CELL_INFO',
      lx_show: false,
      lx_useflag: 0,
      module: 'CellularProviders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'CTTelephonyNetworkInfo#subscriberCellularProvider',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '运营商',
      lx_description: '运营商信息',
      lx_module: 'CELL_INFO',
      lx_show: false,
      lx_useflag: 0,
      module: 'CellularProviders',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'CNContactStore#enumerateContactsWithFetchRequest:error:usingBlock:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      lx_description: '通讯录',
      lx_module: 'CONTACTS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Contacts',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CNContactStore#enumeratorForChangeHistoryFetchRequest:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      lx_description: '通讯录',
      lx_module: 'CONTACTS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Contacts',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CNContactStore#enumeratorForContactFetchRequest:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      lx_description: '通讯录',
      lx_module: 'CONTACTS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Contacts',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CNContactStore#executeSaveRequest:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      lx_description: '通讯录',
      lx_module: 'CONTACTS',
      lx_show: false,
      lx_useflag: 1,
      module: 'Contacts',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CNContactStore#requestAccessForEntityType:completionHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通讯录',
      lx_description: '通讯录',
      lx_module: 'CONTACTS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Contacts',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: '#sysctl',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '设备信息',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'DeviceInfo',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: '#sysctlbyname',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '设备信息',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'DeviceInfo',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: '#uname',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '设备信息',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'DeviceInfo',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'UIDevice#model',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '设备信息',
      lx_description: '手机型号',
      lx_module: 'PHONE_MODEL',
      lx_show: false,
      lx_useflag: 0,
      module: 'DeviceInfo',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'UIDevice#name',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '设备信息',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'DeviceInfo',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'LAContext#canEvaluatePolicy:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'FaceID',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'FaceID',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'LAContext#evaluateAccessControl:operation:localizedReason:reply:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'FaceID',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'FaceID',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'LAContext#evaluatePolicy:localizedReason:reply:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'FaceID',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'FaceID',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'HKHealthStore#requestAuthorizationToShareTypes:readTypes:completion:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '健康',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Health',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'HMHomeManager#addHomeWithName:completionHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: 'HomeKit',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'HomeKit',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIDevice#identifierForVendor',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: 'IDFV',
      lx_description: 'IDFV',
      lx_module: 'IDFV',
      lx_show: false,
      lx_useflag: 1,
      module: 'IDFV',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'CLLocationManager#requestAlwaysAuthorization',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '定位',
      lx_description: '位置',
      lx_module: 'FINE_LOCATION',
      lx_show: true,
      lx_useflag: 0,
      module: 'Location',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CLLocationManager#requestLocation',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '定位',
      lx_description: '位置',
      lx_module: 'FINE_LOCATION',
      lx_show: false,
      lx_useflag: 1,
      module: 'Location',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CLLocationManager#requestWhenInUseAuthorization',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '定位',
      lx_description: '位置',
      lx_module: 'FINE_LOCATION',
      lx_show: true,
      lx_useflag: 0,
      module: 'Location',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CLLocationManager#startUpdatingLocation',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '定位',
      lx_description: '位置',
      lx_module: 'FINE_LOCATION',
      lx_show: true,
      lx_useflag: 0,
      module: 'Location',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVAudioRecorder#record',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      lx_description: '麦克风',
      lx_module: 'AUDIOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Microphone',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVAudioRecorder#recordAtTime:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      lx_description: '麦克风',
      lx_module: 'AUDIOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Microphone',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVAudioRecorder#recordForDuration:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      lx_description: '麦克风',
      lx_module: 'AUDIOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Microphone',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'AVAudioSession#requestRecordPermission:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '麦克风',
      lx_description: '麦克风',
      lx_module: 'AUDIOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'Microphone',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMAltimeter#startAbsoluteAltitudeUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMAltimeter#startRelativeAltitudeUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMHeadphoneMotionManager#startDeviceMotionUpdates',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMHeadphoneMotionManager#startDeviceMotionUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionActivityManager#queryActivityStartingFromDate:toDate:toQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionActivityManager#startActivityUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startAccelerometerUpdates',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startAccelerometerUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startDeviceMotionUpdates',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startDeviceMotionUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startDeviceMotionUpdatesUsingReferenceFrame:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startDeviceMotionUpdatesUsingReferenceFrame:toQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startGyroUpdates',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startGyroUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startMagnetometerUpdates',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMMotionManager#startMagnetometerUpdatesToQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMPedometer#queryPedometerDataFromDate:toDate:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMPedometer#startPedometerEventUpdatesWithHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMPedometer#startPedometerUpdatesFromDate:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: true,
      lx_useflag: 0,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMSensorRecorder#accelerometerDataFromDate:toDate:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMSensorRecorder#accelerometerDataSince:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMSensorRecorder#recordAccelerometerForDuration:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMStepCounter#queryStepCountStartingFrom:to:toQueue:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'CMStepCounter#startStepCountingUpdatesToQueue:updateOn:withHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '运动与健身',
      lx_description: '运动与健身',
      lx_module: 'SENSOR',
      lx_show: false,
      lx_useflag: 1,
      module: 'Motion',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIApplication#registerUserNotificationSettings:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通知',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Notification',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UNUserNotificationCenter#requestAuthorizationWithOptions:completionHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '通知',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Notification',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#URL',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#URLs',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#color',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#colors',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#image',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#images',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#string',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'UIPasteboard#strings',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '剪切板',
      lx_description: '剪切板',
      lx_module: 'CLIPBOARD',
      lx_show: true,
      lx_useflag: 0,
      module: 'Pasteboard',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHAsset#fetchAssetsInAssetCollection:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: false,
      lx_useflag: 1,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHAssetCollection#fetchAssetCollectionsContainingAsset:withType:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHAssetCollection#fetchAssetCollectionsWithALAssetGroupURLs:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHAssetCollection#fetchAssetCollectionsWithLocalIdentifiers:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHAssetCollection#fetchAssetCollectionsWithType:subtype:options:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHImageManager#requestAVAssetForVideo:options:resultHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHImageManager#requestImageDataForAsset:options:resultHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: false,
      lx_useflag: 1,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHImageManager#requestPlayerItemForVideo:options:resultHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHPhotoLibrary#performChanges:completionHandler:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHPhotoLibrary#performChangesAndWait:error:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHPhotoLibrary#registerChangeObserver:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'PHPhotoLibrary#requestAuthorization:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '相册',
      lx_description: '多媒体文件',
      lx_module: 'PHOTOS',
      lx_show: true,
      lx_useflag: 0,
      module: 'PhotoLibrary',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'SFSpeechRecognizer#requestAuthorization:',
      configStrategies: [
        'ban',
        'normal',
      ],
      description: '语音识别',
      lx_description: null,
      lx_module: null,
      lx_show: false,
      lx_useflag: 1,
      module: 'Speech',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: false,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
      ],
      supportSilence: true,
    },
    {
      api: 'ASIdentifierManager#advertisingIdentifier',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '用户追踪',
      lx_description: 'IDFA',
      lx_module: 'IDFA',
      lx_show: false,
      lx_useflag: 0,
      module: 'UserTracking',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'ATTrackingManager#requestTrackingAuthorizationWithCompletionHandler:',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: '用户追踪',
      lx_description: 'IDFA',
      lx_module: 'IDFA',
      lx_show: false,
      lx_useflag: 0,
      module: 'UserTracking',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: '#CNCopyCurrentNetworkInfo',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: 'WI-FI',
      lx_description: 'IP地址',
      lx_module: 'IP_ADDRESS',
      lx_show: false,
      lx_useflag: 1,
      module: 'Wi-Fi',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'NEHotspotHelper#supportedNetworkInterfaces',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: 'WI-FI',
      lx_description: '附近的Wi-Fi',
      lx_module: 'NEARBY_WIFI',
      lx_show: false,
      lx_useflag: 0,
      module: 'Wi-Fi',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
    {
      api: 'NEHotspotNetwork#fetchCurrentWithCompletionHandler:',
      configStrategies: [
        'ban',
        'memory',
        'cache_only',
        'storage',
        'normal',
      ],
      description: 'WI-FI',
      lx_description: '连接的Wi-Fi',
      lx_module: 'CONNECTED_WIFI',
      lx_show: false,
      lx_useflag: 1,
      module: 'Wi-Fi',
      suggestHighFreq: 'high',
      suggestRule: 'normal_normal',
      suggestSilence: 'five_second',
      supportCacheTime: true,
      supportHighFreq: true,
      supportRules: [
        'ban_ban',
        'ban_normal',
        'normal_normal',
        'ban_cache',
        'cache_cache',
        'cacheOnly_cache',
        'cacheOnly_normal',
        'ban_storage',
        'storage_storage',
      ],
      supportSilence: true,
    },
  ],
  CacheTime: [
    {
      description: '缓存有效时长1分钟',
      time: 'one_minute',
    },
    {
      description: '缓存有效时长5分钟',
      time: 'five_minute',
    },
    {
      description: '缓存有效时长15分钟',
      time: 'quarter_hour',
    },
    {
      description: '缓存有效时长1小时',
      time: 'one_hour',
    },
    {
      description: '缓存有效时长1天',
      time: 'one_day',
    },
    {
      description: '缓存长期有效',
      time: 'always',
    },
  ],
  General: {
    CacheTime: {
      always: '缓存长期有效',
      five_minute: '缓存有效时长5分钟',
      one_day: '缓存有效时长1天',
      one_hour: '缓存有效时长1小时',
      one_minute: '缓存有效时长1分钟',
      quarter_hour: '缓存有效时长15分钟',
    },
    HighFreq: {
      high: '10秒6次调用认为是高频调用，兜底使用前台规则',
      higher: '10秒60次调用认为是高频调用，兜底使用前台规则',
      low: '10分钟20次调用认为是高频调用，兜底使用前台规则',
      lower: '24小时2次调用认为是高频调用，兜底使用前台规则',
      middle: '1分钟10次调用认为是高频调用，兜底使用前台规则',
    },
    Scene: {
      back: '后台调用场景',
      before: '隐私协议未同意前调用场景',
      global: '全局(用户)抽样',
      high_freq: '高频调用场景',
      illegal_scene: '非法页面调用场景',
      silence: '静默调用场景',
    },
    Silence: {
      five_second: '用户无操作5秒后有调用认为是静默调用，兜底使用前台规则',
      half_minute: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
      one_minute: '用户无操作1分钟后有调用认为是静默调用，兜底使用前台规则',
      quarter_minute: '用户无操作15秒后有调用认为是静默调用，兜底使用前台规则',
      ten_second: '用户无操作10秒后有调用认为是静默调用，兜底使用前台规则',
    },
    Strategy: {
      ban_ban: '隐私协议未同意前禁止调用，后台禁止调用，前台禁止调用',
      ban_cache: '隐私协议未同意前禁止调用，后台禁止调用，前台使用内存缓存',
      ban_normal: '隐私协议未同意前禁止调用，后台禁止调用，前台直接调用',
      ban_storage: '隐私协议未同意前禁止调用，后台禁止调用，前台使用持久化缓存',
      cacheOnly_cache: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台使用内存缓存',
      cacheOnly_normal: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台直接调用',
      cache_cache: '隐私协议未同意前禁止调用，后台使用内存缓存，前台使用内存缓存',
      normal_normal: '隐私协议未同意前禁止调用，后台直接调用，前台直接调用',
      storage_storage: '隐私协议未同意前禁止调用，后台使用持久化缓存，前台使用持久化缓存',
    },
    Title: {
      api: '合规全局配置说明：\nNORMAL_NORMAL_NORMAL： 所有API的策略为: 未同意隐私前正常调用,后台正常调用,前台正常调用\n(默认)BAN_NORMAL_NORMAL：所有API的策略为: 未同意隐私前禁止调用,后台正常调用,前台正常调用\nBAN_BAN_NORMAL：所有API的策略为: 未同意隐私前禁止调用,后台禁止调用,前台正常调用',
    },
  },
  HighFreq: [
    {
      description: '24小时2次调用认为是高频调用，兜底使用前台规则',
      freq: 'lower',
    },
    {
      description: '10分钟20次调用认为是高频调用，兜底使用前台规则',
      freq: 'low',
    },
    {
      description: '1分钟10次调用认为是高频调用，兜底使用前台规则',
      freq: 'middle',
    },
    {
      description: '10秒6次调用认为是高频调用，兜底使用前台规则',
      freq: 'high',
    },
    {
      description: '10秒60次调用认为是高频调用，兜底使用前台规则',
      freq: 'higher',
    },
  ],
  SampleRate: [
    {
      maxReport: 30,
      rate: 0.001,
      scene: 'global',
    },
    {
      maxReport: 5,
      rate: 0.1,
      scene: 'before',
    },
    {
      maxReport: 5,
      rate: 0.1,
      scene: 'back',
    },
    {
      maxReport: 5,
      rate: 0.1,
      scene: 'high_freq',
    },
    {
      maxReport: 5,
      rate: 0.1,
      scene: 'silence',
    },
    {
      maxReport: 5,
      rate: 0.1,
      scene: 'illegal_scene',
    },
  ],
  Silence: [
    {
      description: '用户无操作5秒后有调用认为是静默调用，兜底使用前台规则',
      time: 'five_second',
    },
    {
      description: '用户无操作10秒后有调用认为是静默调用，兜底使用前台规则',
      time: 'ten_second',
    },
    {
      description: '用户无操作15秒后有调用认为是静默调用，兜底使用前台规则',
      time: 'quarter_minute',
    },
    {
      description: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
      time: 'half_minute',
    },
    {
      description: '用户无操作1分钟后有调用认为是静默调用，兜底使用前台规则',
      time: 'one_minute',
    },
  ],
};
